import * as React from "react";
import {
    PlasmicCanvasSidebar,
    DefaultCanvasSidebarProps
} from "./plasmic/main/PlasmicCanvasSidebar";
import {useEffect, useState} from "react";
import {CanvasStates} from "./CanvasView";

export interface CanvasSidebarProps extends DefaultCanvasSidebarProps {
    canvasState: CanvasStates[],
    showNoteList: (b: boolean) => void,
    showRooms: (b: boolean) => void,
    showSettings: (b: boolean) => void,
    jumpToDefaultPos: () => void,
    showLevels: (b: boolean) => void,
    readonly: boolean
}

type State = "noteList" | "settings" | "levels" | "spaces";


function CanvasSidebar({canvasState, showNoteList, showRooms, showSettings, jumpToDefaultPos, showLevels, readonly, ...rest}: CanvasSidebarProps) {
    const [state, setState] = useState<State[]>([]);
    useEffect(()=> {
        const s: State[] = [];
        canvasState.includes("noteList") && s.push("noteList");
        canvasState.includes("settings") && s.push("settings");
        canvasState.includes("levels") && s.push("levels");
        canvasState.includes("spaces") && s.push("spaces");
        setState(s);
    }, [canvasState]);
    return <PlasmicCanvasSidebar
        {...rest}
        state={state}
        hideSettings={readonly}
        listButton={{
            onClick: () => showNoteList(!state.includes('noteList'))
        }}
        spacesButton={{
            onClick: () => showRooms(!state.includes('spaces'))
        }}
        centerButton={{
            onClick: () => jumpToDefaultPos()
        }}
        settingsButton={{
            onClick: () => showSettings(!state.includes('settings'))
        }}
        levelsButton={{
            onClick: () => showLevels(!state.includes('levels'))
        }}
    />;
}

export default CanvasSidebar;
